import styled from 'styled-components';
import {
  TextField,
} from '@mui/material';
import colors from '../../../../styles/colors';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 60px;
`;

const Title = styled.div`
  flex: 1;
  font-size: 24px;
  white-space: nowrap;
  text-align: center;
  margin: 20px;
`;

const StyledTextField = styled(TextField)`
  margin-bottom: 20px;
  width: 100%;
`;

const Subtitle = styled.div`
  text-align: center;
  margin-bottom: 10px;
  color: #666;
  font-size: 14px;
`;

const HelpText = styled.div`
  font-size: 15px;
  margin-bottom: 16px;
  color: ${colors.base.secondary};
  cursor: pointer;
  text-decoration: underline;
  text-align: center;
  
  &:hover {
    color: ${colors.base.secondary2};
  }
`;

export {
  Container,
  Title,
  StyledTextField,
  Subtitle,
  HelpText,
};
